import PgHome from './pages/pghome.vue'
import PgVideo from './pages/pgvideo.vue'
import PgCategory from './pages/pgcategory.vue'
import PgAllCategories from './pages/pgallcategories.vue'
import PgSearchResults from './pages/pgsearchresults.vue'
PgAllCategories

const routers = [
    // {
    //     path: '*',
    //     // name: 'home',
    //     component: NTF
    // },
    {
        path: '/',
        name: 'home',
        component: PgHome
    },
    {
        path: '/category/:cateory_name',
        name: 'category',
        component: PgCategory
    },
    {
        path: '/categories',
        name: 'categories',
        component: PgAllCategories
    },
    {
        path: '/video/:id',
        name: 'video',
        component: PgVideo
    },
    {
        path: '/search/:keywords',
        name: 'search',
        component: PgSearchResults
    }


]
export default routers